import api from '@/libs/axios'
import { TypeActionPreventionSantePublique } from '../models/preventionSantePublique/typeActionPreventionSantePublique';
import { PaginatedList } from '../models/common/paginatedList'

const resource = 'TypesActionPreventionSantePublique'

export default class TypesActionPreventionSantePubliqueRessource {
  public async paginatedList(pagenumber?: number, pagesize?: number, actifOnly?: boolean): Promise<PaginatedList<TypeActionPreventionSantePublique>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString());
    if (pagesize) params.append('PageSize', pagesize.toString());
    if (actifOnly) params.append('ActifOnly', actifOnly.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
